import React from "react";

export interface TooltipProps {
  text: string;
  children: React.ReactNode;
}
export const Tooltip = (props: TooltipProps) => {
  const [visible, setVisible] = React.useState(false);
  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
      }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {props.children}
      {visible && (
        <div
          style={{
            position: "absolute",
            zIndex: "100000",
            bottom: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            marginBottom: "6px",
            backgroundColor: "#000",
            color: "#fff",
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.3)",
            pointerEvents: "none",
          }}
        >
          {props.text}
        </div>
      )}
    </div>
  );
};
